"use strict";

document.addEventListener("DOMContentLoaded", () => {
    var adpPopup = {};

    (function () {
        var $this;

        adpPopup = {
            sPrevious: window.scrollY,
            sDirection: "down",

            init: function () {
                $this = adpPopup;
                $this.popupInit();
                $this.setupEvents();
            },

            setupEvents: function () {
                document.addEventListener("click", $this.handleButtonClick);
                document.addEventListener("keyup", $this.handleKeyPress);
                document.addEventListener("click", $this.handleOverlayClick);
            },

            popupInit: function () {
                document.addEventListener("scroll", $this.updateScrollDirection);

                var popups = document.querySelectorAll(".popup");
                if (popups.length) {
                    popups.forEach($this.setupPopup);
                }
            },

            updateScrollDirection: function () {
                let scrollCurrent = window.scrollY;
                $this.sDirection = scrollCurrent > $this.sPrevious ? "down" : "up";
                $this.sPrevious = scrollCurrent;
            },

            setupPopup: function (popup) {
                if (!$this.isAllowPopup(popup)) return;
                $this.openTriggerPopup(popup);
            },

            focusOnClose: function () {
                const skipLink = document.querySelector(
                    'a[href="#MainContent"], a[href="#main-content"], a.skip-link, a.skip-to-content'
                );

                if (skipLink) {
                    skipLink.setAttribute("tabindex", "-1");
                    skipLink.focus();
                } else {
                    const header = document.querySelector("header, .site-header, #shopify-section-header");
                    if (header) {
                        header.setAttribute("tabindex", "-1");
                        header.focus();
                    } else {
                        document.body.setAttribute("tabindex", "-1");
                        document.body.focus();
                    }
                }
            },

            handleButtonClick: function (e) {
                const target = e.target;

                if (target.classList.contains("popup-close") || target.closest(".popup-close")) {
                    $this.closePopup(target.closest('.popup'));
                }

                if (target.classList.contains("popup-accept") || target.closest(".popup-accept")) {
                    $this.acceptPopup(target);
                    $this.closePopup(target.closest('.popup'));
                }
            },

            handleKeyPress: function (e) {
                if (e.key === "Escape") {
                    $this.closePopupsByAttribute("data-esc-close");
                    $this.focusOnClose();
                }
                if (e.key === "F4") {
                    $this.closePopupsByAttribute("data-f4-close");
                    $this.focusOnClose();
                }
            },

            handleOverlayClick: function (e) {
                if (e.target.classList.contains("popup-overlay")) {
                    $this.closePopupsByAttribute("data-overlay-close");
                    $this.focusOnClose();
                }
            },

            closePopupsByAttribute: function (attribute) {
                var closeItems = document.querySelectorAll(`.popup-open[${attribute}="true"]`);
                closeItems.forEach($this.closePopup);
            },

            isAllowPopup: function (popup) {
                let limitDisplay = parseInt(popup.dataset.limitDisplay || 0);
                let limitDisplayCookie = parseInt($this.getCookie("popup-" + popup.dataset.id));
                return !(limitDisplay && limitDisplayCookie && limitDisplayCookie >= limitDisplay);
            },

            openTriggerPopup: function (popup) {
                var trigger = popup.dataset.openTrigger;

                if ("delay" === trigger) {
                    setTimeout(() => $this.openPopup(popup), popup.dataset.openDelayNumber * 1000);
                }

                if ("exit" === trigger) {
                    var showExit = true;
                    document.addEventListener("mousemove", function (event) {
                        var scroll = window.pageYOffset || document.documentElement.scrollTop;
                        if (event.pageY - scroll < 7 && showExit) {
                            $this.openPopup(popup);
                            showExit = false;
                        }
                    });
                }

                if ("scroll" === trigger) {
                    var type = popup.dataset.openScrollType;
                    var pos = parseFloat(popup.dataset.openScrollPosition);

                    document.addEventListener("scroll", () => {
                        const condition =
                            type === "px" ? window.scrollY >= pos :
                                $this.getScrollPercent() >= pos;

                        if (condition) $this.openPopup(popup);
                    });
                }

                if ("on_click" === trigger) {
                    var subscribeButton = document.querySelector('.subscribe_now');
                    if (subscribeButton) {
                        subscribeButton.addEventListener('click', function() {
                            $this.openPopup(popup);
                        });
                        
                    }
				}
            },

            closeTriggerPopup: function (popup) {
                var trigger = popup.dataset.closeTrigger;

                if ("delay" === trigger) {
                    setTimeout(() => $this.closePopup(popup), popup.dataset.closeDelayNumber * 1000);
                }

                if ("scroll" === trigger) {
                    var type = popup.dataset.closeScrollType;
                    var pos = parseFloat(popup.dataset.closeScrollPosition);
                    var initPx = parseFloat(popup.dataset.initScrollPx);
                    var initPercent = parseFloat(popup.dataset.initScrollPercent);

                    document.addEventListener("scroll", () => {
                        const condUp =
                            type === "px" && $this.sDirection === "up" &&
                            window.scrollY < initPx - pos;

                        const condDown =
                            type === "px" && $this.sDirection === "down" &&
                            window.scrollY >= initPx + pos;

                        const condPercentUp =
                            type === "%" && $this.sDirection === "up" &&
                            $this.getScrollPercent() < initPercent - pos;

                        const condPercentDown =
                            type === "%" && $this.sDirection === "down" &&
                            $this.getScrollPercent() >= initPercent + pos;

                        if (condUp || condDown || condPercentUp || condPercentDown) {
                            $this.closePopup(popup);
                        }
                    });
                }
            },

            openPopup: function (popup) {
                if (
                    popup.getAttribute("data-body-scroll-disable") == 'true' &&
                    !popup.classList.contains("popup-already-opened")
                ) {
                    document.body.classList.add("popup-scroll-hidden");
                }

                // let limit = parseInt($this.getCookie("popup-" + popup.dataset.id) || 0) + 1;
                // $this.setCookie("popup-" + popup.dataset.id, limit, {
                //     expires: popup.dataset.limitLifetime,
                // });

                if (popup.dataset.openTrigger === "on_click") {
                    document.body.classList.add("popup-scroll-hidden");
                    popup.classList.remove("popup-already-opened");
                }

                if (popup.classList.contains("popup-open") ||
                    popup.classList.contains("popup-already-opened")) return;

                popup.classList.add("popup-open");

                setTimeout(() => popup.classList.add("popup_smooth"), 600);

                popup.dataset.initScrollPx = window.scrollY;
                popup.dataset.initScrollPercent = $this.getScrollPercent();

                let animation = popup.dataset.openAnimation;
                $this.applyAnimation(popup, animation);

                $this.setupNewsletterActions(popup);

                $this.enableFocusTrap(popup);

                $this.closeTriggerPopup(popup);
            },

            closePopup: function (popup) {
                let animation = popup.dataset.exitAnimation;
                $this.applyAnimation(popup, animation, function () {

                    popup.classList.add("popup-already-opened");
                    popup.classList.remove("popup-open");
                    document.body.classList.remove("popup-scroll-hidden");

                    $this.disableFocusTrap();

                    $this.focusOnClose();
                });
            },

            acceptPopup: function (popup) {
                $this.setCookie("popup-accept-" + popup.dataset.id, 1, { expires: 360 });
            },

            setupNewsletterActions: function (popup) {
                const form = popup.querySelector("form");
                if (form) {
                    form.querySelector('input[type="email"]').focus();
                    const button = form.querySelector(`button[type="submit"]`);

                    button.addEventListener("click", function (event) {
                        event.preventDefault();
                        form.submit();
                    });
                }
            },
            trapFocusHandler: null,

            enableFocusTrap: function (popup) {
                const focusable = Array.from(
                    popup.querySelectorAll(
                        'a[href], button:not([disabled]), textarea, input:not([disabled]), select, [tabindex]:not([tabindex="-1"])'
                    )
                ).filter(el => el.offsetParent !== null);

                if (focusable.length === 0) return;

                const first = focusable[0];
                const last = focusable[focusable.length - 1];

                first.focus();

                $this.trapFocusHandler = function (e) {
                    if (e.key !== "Tab") return;

                    if (e.shiftKey) {
                        if (document.activeElement === first) {
                            e.preventDefault();
                            last.focus();
                        }
                    }
                    else {
                        if (document.activeElement === last) {
                            e.preventDefault();
                            first.focus();
                        }
                    }
                };

                document.addEventListener("keydown", $this.trapFocusHandler);
            },

            disableFocusTrap: function () {
                if ($this.trapFocusHandler) {
                    document.removeEventListener("keydown", $this.trapFocusHandler);
                    $this.trapFocusHandler = null;
                }
            },

            applyAnimation: function (popup, name, callback) {
                popup.classList.remove("popup_smooth");
                var overlayName = typeof callback === "function" ? "popupExitFade" : "popupOpenFade";

                if (popup.nextSibling !== null) {
                    popup.nextSibling.classList.add("popup-animated", overlayName);
                }

                ["animationend", "webkitAnimationEnd", "oanimationend"].forEach((event) => {
                    if (popup.nextSibling !== null) {
                        popup.nextSibling.addEventListener(
                            event,
                            function () {
                                this.classList.remove("popup-animated", overlayName);
                            },
                            { once: true }
                        );
                    }
                });

                const popupWrap = popup.querySelector(".popup-wrap");
                popupWrap.classList.add("popup-animated", name);

                ["animationend", "webkitAnimationEnd", "oanimationend"].forEach((event) => {
                    popupWrap.addEventListener(
                        event,
                        function () {
                            this.classList.remove("popup-animated", name);
                            if (typeof callback === "function") callback();
                        },
                        { once: true }
                    );
                });
            },

            getCookie: function (name) {
                var matches = document.cookie.match(
                    new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)")
                );
                return matches ? decodeURIComponent(matches[1]) : undefined;
            },

            setCookie: function (name, value, options) {
                options = options || {};
                options.path = options.path ?? "/";

                if (typeof options.expires === "number" && options.expires > 0) {
                    options.expires = new Date(Date.now() + options.expires * 86400000).toUTCString();
                }

                value = encodeURIComponent(value);
                let updatedCookie = `${name}=${value}`;

                for (var [prop, val] of Object.entries(options)) {
                    if (typeof val !== "boolean") {
                        updatedCookie += `; ${prop}=${val}`;
                    } else if (val) {
                        updatedCookie += `; ${prop}`;
                    }
                }

                document.cookie = updatedCookie;
            },

            getScrollPercent: function () {
                var h = document.documentElement,
                    b = document.body,
                    st = "scrollTop",
                    sh = "scrollHeight";
                return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
            }
        };
    })();

    adpPopup.init();

    document.addEventListener("shopify:section:load", adpPopup.init);
    document.addEventListener("shopify:section:unload", () => {
        document.body.classList.remove("popup-scroll-hidden");
    });
});
